var _g, _circle, _path, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 56,
    viewBox: "0 0 117 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4658_28581)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 15,
    width: 66,
    height: 27,
    rx: 8,
    fill: "white"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 28,
    r: 28,
    fill: "#0E9658"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.312 34V22.32H21.936V34H19.312ZM21.616 29.296V27.12H26.128V29.296H21.616ZM21.616 24.496V22.32H26.32V24.496H21.616ZM26.6111 34L30.4671 22.32H34.7071L38.7071 34H35.9871L32.7551 24.128L33.5871 24.464H31.5231L32.3871 24.128L29.2351 34H26.6111ZM29.5391 31.104L30.3391 28.928H34.9151L35.7311 31.104H29.5391ZM47.8344 37.488C47.109 37.488 46.4797 37.4027 45.9464 37.232C45.4237 37.0613 45.013 36.752 44.7144 36.304C44.4264 35.856 44.2824 35.216 44.2824 34.384V32.592H46.7304V34.496C46.7304 34.8053 46.8157 35.04 46.9864 35.2C47.1677 35.3707 47.413 35.456 47.7224 35.456H49.4664V37.488H47.8344ZM45.5464 34.304C44.4904 34.304 43.5677 34.1227 42.7784 33.76C41.9997 33.3867 41.3544 32.9013 40.8424 32.304C40.3304 31.696 39.9464 31.04 39.6904 30.336C39.445 29.632 39.3224 28.9547 39.3224 28.304V27.952C39.3224 27.2267 39.4504 26.512 39.7064 25.808C39.973 25.0933 40.3677 24.448 40.8904 23.872C41.413 23.296 42.0637 22.8373 42.8424 22.496C43.621 22.144 44.5224 21.968 45.5464 21.968C46.5704 21.968 47.4717 22.144 48.2504 22.496C49.029 22.8373 49.6797 23.296 50.2024 23.872C50.725 24.448 51.1197 25.0933 51.3864 25.808C51.653 26.512 51.7864 27.2267 51.7864 27.952V28.304C51.7864 28.9547 51.6584 29.632 51.4024 30.336C51.1464 31.04 50.7624 31.696 50.2504 32.304C49.7384 32.9013 49.0877 33.3867 48.2984 33.76C47.5197 34.1227 46.6024 34.304 45.5464 34.304ZM45.5464 31.856C46.101 31.856 46.597 31.76 47.0344 31.568C47.4824 31.376 47.861 31.1093 48.1704 30.768C48.4904 30.4267 48.7304 30.032 48.8904 29.584C49.0504 29.136 49.1304 28.656 49.1304 28.144C49.1304 27.6 49.045 27.104 48.8744 26.656C48.7144 26.1973 48.4744 25.8027 48.1544 25.472C47.845 25.1307 47.4717 24.8693 47.0344 24.688C46.597 24.5067 46.101 24.416 45.5464 24.416C44.9917 24.416 44.4957 24.5067 44.0584 24.688C43.621 24.8693 43.2424 25.1307 42.9224 25.472C42.613 25.8027 42.3784 26.1973 42.2184 26.656C42.0584 27.104 41.9784 27.6 41.9784 28.144C41.9784 28.656 42.0584 29.136 42.2184 29.584C42.3784 30.032 42.613 30.4267 42.9224 30.768C43.2424 31.1093 43.621 31.376 44.0584 31.568C44.4957 31.76 44.9917 31.856 45.5464 31.856Z",
    fill: "#046639"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4658_28581)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89 41.3334C81.636 41.3334 75.6666 35.364 75.6666 28C75.6666 20.636 81.636 14.6667 89 14.6667C96.364 14.6667 102.333 20.636 102.333 28C102.333 35.364 96.364 41.3334 89 41.3334ZM89 38.6667C91.8289 38.6667 94.542 37.5429 96.5424 35.5425C98.5428 33.5421 99.6666 30.829 99.6666 28C99.6666 25.171 98.5428 22.4579 96.5424 20.4575C94.542 18.4572 91.8289 17.3334 89 17.3334C86.171 17.3334 83.4579 18.4572 81.4575 20.4575C79.4571 22.4579 78.3333 25.171 78.3333 28C78.3333 30.829 79.4571 33.5421 81.4575 35.5425C83.4579 37.5429 86.171 38.6667 89 38.6667ZM87.6666 32H90.3333V34.6667H87.6666V32ZM90.3333 29.8067V30.6667H87.6666V28.6667C87.6666 28.3131 87.8071 27.9739 88.0572 27.7239C88.3072 27.4738 88.6463 27.3334 89 27.3334C89.3787 27.3333 89.7497 27.2257 90.0697 27.0231C90.3897 26.8205 90.6456 26.5312 90.8077 26.1888C90.9697 25.8464 91.0311 25.4651 90.9849 25.0891C90.9386 24.7132 90.7866 24.3581 90.5464 24.0652C90.3062 23.7723 89.9878 23.5537 89.6283 23.4346C89.2687 23.3156 88.8827 23.3012 88.5152 23.393C88.1477 23.4847 87.8138 23.679 87.5524 23.9531C87.291 24.2272 87.1129 24.5699 87.0386 24.9414L84.4226 24.4174C84.5848 23.6068 84.9593 22.8538 85.5079 22.2355C86.0564 21.6171 86.7593 21.1555 87.5447 20.8978C88.3302 20.6401 89.1699 20.5956 89.9782 20.7688C90.7865 20.9421 91.5342 21.3268 92.1451 21.8838C92.7559 22.4407 93.2079 23.1499 93.4548 23.9388C93.7017 24.7276 93.7347 25.5679 93.5504 26.3738C93.3662 27.1796 92.9712 27.922 92.406 28.5252C91.8407 29.1283 91.1255 29.5706 90.3333 29.8067Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4658_28581",
    x: 0,
    y: 5,
    width: 86,
    height: 47,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.458824 0 0 0 0 0.458824 0 0 0 0 0.458824 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4658_28581"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4658_28581",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4658_28581"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(73 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/FAQ.3506baeb49ffec0da9c2df9f0c507ce4.svg";
export { ForwardRef as ReactComponent };